// import React, { useState } from 'react';
// import { NavLink } from 'react-router-dom';
// import { 
//     FaBoxOpen, 
//     FaPlusCircle, 
//     FaTicketAlt, 
//     FaWarehouse, 
//     FaShoppingBag, 
//     FaHistory, 
//     FaBars, 
//     FaTimes 
// } from 'react-icons/fa';

// const AdminSidebar = () => {
//     const [isOpen, setIsOpen] = useState(false);

//     const menuItems = [
//         { path: "/product", label: "Products", icon: <FaBoxOpen /> },
//         { path: "/product-upload", label: "Upload Product", icon: <FaPlusCircle /> },
//         { path: "/inventory", label: "Inventory", icon: <FaWarehouse /> },
//         { path: "/order", label: "Orders", icon: <FaShoppingBag /> },
//         { path: "/purchase", label: "Purchase History", icon: <FaHistory /> },
//         { path: "/coupons", label: "Coupons", icon: <FaTicketAlt /> },
//         { path: "/artist", label: "Artists", icon: <FaTicketAlt /> },
//     ];

//     const toggleSidebar = () => setIsOpen(!isOpen);

//     return (
//         <>
//             {/* Mobile Header */}
//             <div className="lg:hidden bg-slate-900 text-white p-4 flex justify-between items-center shadow-md">
//                 <span className="font-serif italic text-xl tracking-wider">Kanthasri Admin</span>
//                 <button onClick={toggleSidebar} className="text-2xl focus:outline-none">
//                     {isOpen ? <FaTimes /> : <FaBars />}
//                 </button>
//             </div>

//             {/* Sidebar Container */}
//             <div className={`
//                 fixed lg:static inset-y-0 left-0 z-50
//                 w-64 bg-slate-900 text-slate-300 min-h-screen transition-transform duration-300 transform
//                 ${isOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0
//             `}>
//                 {/* Brand Logo Area */}
//                 <div className="p-8 border-b border-slate-800">
//                     <h1 className="text-white font-serif italic text-2xl tracking-widest">Kanthasri</h1>
//                     <p className="text-[10px] uppercase tracking-[0.3em] text-slate-500 mt-1 font-bold">Management Portal</p>
//                 </div>

//                 {/* Navigation Links */}
//                 <nav className="mt-6 px-4 space-y-2">
//                     {menuItems.map((item) => (
//                         <NavLink
//                             key={item.path}
//                             to={item.path}
//                             onClick={() => setIsOpen(false)}
//                             className={({ isActive }) => `
//                                 flex items-center gap-4 px-4 py-3 rounded-sm transition-all duration-200 group
//                                 ${isActive 
//                                     ? "bg-amber-600 text-white shadow-lg shadow-amber-900/20" 
//                                     : "hover:bg-slate-800 hover:text-white"}
//                             `}
//                         >
//                             <span className="text-lg">{item.icon}</span>
//                             <span className="text-xs uppercase tracking-widest font-bold">{item.label}</span>
//                         </NavLink>
//                     ))}
//                 </nav>

//                 {/* Bottom Logout/User Info (Optional) */}
//                 <div className="absolute bottom-0 w-full p-6 border-t border-slate-800 bg-slate-900">
//                     <div className="flex items-center gap-3">
//                         <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-[10px] text-white">
//                             AD
//                         </div>
//                         <span className="text-[10px] uppercase tracking-widest text-slate-400">Admin Session</span>
//                     </div>
//                 </div>
//             </div>

//             {/* Overlay for mobile when sidebar is open */}
//             {isOpen && (
//                 <div 
//                     className="fixed inset-0 bg-black/50 z-40 lg:hidden" 
//                     onClick={toggleSidebar}
//                 />
//             )}
//         </>
//     );
// };

// export default AdminSidebar;

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { 
    FaBoxOpen, FaPlusCircle, FaTicketAlt, FaWarehouse, 
    FaShoppingBag, FaHistory, FaBars, FaTimes, FaHome 
} from 'react-icons/fa';

const AdminSidebar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const menuItems = [
        { path: "/", label: "Dashboard", icon: <FaHome /> }, // Added Home
        { path: "/product", label: "Products", icon: <FaBoxOpen /> },
        { path: "/product-upload", label: "Upload Product", icon: <FaPlusCircle /> },
        { path: "/inventory", label: "Inventory", icon: <FaWarehouse /> },
        { path: "/order", label: "Orders", icon: <FaShoppingBag /> },
        { path: "/purchase", label: "Purchase History", icon: <FaHistory /> },
        { path: "/coupons", label: "Coupons", icon: <FaTicketAlt /> },
        { path: "/artist", label: "Artists", icon: <FaTicketAlt /> },
        { path: "/cart", label: "Carts", icon: <FaTicketAlt /> },
        { path: "/assign-coupon", label: "Assign Coupon", icon: <FaTicketAlt /> },
    ];

    const toggleSidebar = () => setIsOpen(!isOpen);

    return (
        <>
            {/* 1. Floating Mobile Toggle Button - Better than a full bar */}
            <button 
                onClick={toggleSidebar} 
                className="lg:hidden fixed bottom-6 right-6 z-[60] bg-amber-600 text-white p-4 rounded-full shadow-2xl active:scale-95 transition-transform"
            >
                {isOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
            </button>

            {/* 2. Sidebar Container */}
            <aside className={`
                fixed lg:sticky top-0 left-0 z-50
                w-72 bg-slate-900 text-slate-300 h-screen transition-transform duration-300 ease-in-out
                ${isOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0
                border-r border-slate-800
            `}>
                {/* Brand Logo Area */}
                <div className="p-8 border-b border-slate-800">
                    <h1 className="text-white font-serif italic text-2xl tracking-widest">Kanthasri</h1>
                    <p className="text-[10px] uppercase tracking-[0.3em] text-slate-500 mt-1 font-bold">Management Portal</p>
                </div>

                {/* Navigation Links */}
                <nav className="mt-6 px-4 space-y-2 overflow-y-auto h-[calc(100vh-200px)] custom-scrollbar">
                    {menuItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={() => setIsOpen(false)}
                            className={({ isActive }) => `
                                flex items-center gap-4 px-4 py-3 rounded-sm transition-all duration-200 group
                                ${isActive 
                                    ? "bg-amber-600 text-white shadow-lg shadow-amber-900/20" 
                                    : "hover:bg-slate-800 hover:text-white"}
                            `}
                        >
                            <span className="text-lg">{item.icon}</span>
                            <span className="text-xs uppercase tracking-widest font-bold">{item.label}</span>
                        </NavLink>
                    ))}
                </nav>

                {/* Admin Session Info */}
                <div className="absolute bottom-0 w-full p-6 border-t border-slate-800 bg-slate-900">
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-[10px] text-white font-bold">
                            KS
                        </div>
                        <div className="flex flex-col">
                            <span className="text-[10px] uppercase tracking-widest text-slate-200 font-bold">Admin</span>
                            <span className="text-[9px] text-slate-500 uppercase tracking-tighter font-medium">Kanthasri Session</span>
                        </div>
                    </div>
                </div>
            </aside>

            {/* 3. Backdrop Overlay for mobile */}
            {isOpen && (
                <div 
                    className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-40 lg:hidden transition-opacity" 
                    onClick={toggleSidebar}
                />
            )}
        </>
    );
};

export default AdminSidebar;